module.exports = __webpack_public_path__ + "img/buy-btn1x.fc410c42.png";